import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import router from './router'
import App from './App.vue'
import 'ant-design-vue/dist/reset.css'



createApp(App).use(router).use(Antd).mount('#app')

const serviceUrl = {
    // frontendUrl: '192.168.66.110:8080',
    // backendUrl: '192.168.66.110:1940',
    backendUrl: '39.108.169.193:1935/newfaculty/',
    // backendUrl: '192.168.66.87:1940',
}

export default serviceUrl